exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".privacy-policy-content-box .default-sub-title {\n    margin: 30px 0 0 0;\n}\n.privacy-policy-content-box p {\n  padding: 0;\n  margin: 0 0 15px 0;\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #777;\n  text-align: justify;\n}\n", ""]);

